export default __webpack_public_path__ + "static/media/linkedin.4065a637.svg";